export class Card {
  constructor(data) {
    this.address = data.address;
    this.approveCode = data.approveCode;
    this.avsCode = data.avsCode;
    this.cvv = data.cvv;
    this.cvvCode = data.cvvCode;
    this.expireMonth = data.expireMonth;
    this.expireYear = data.expireYear;
    this.name = data.name;
    this.number = data.number;
    this.paymentId = data.paymentId;
    this.transactionId = data.transactionId;
    this.type = data.type;
    this.zip = data.zip;
  }
}

export class CardDefaultUpdate {
  constructor(data) {
    this.paymentProfileId = data.paymentProfileId;
    this.groupAdminId = data.groupAdminId;
  }
}
